export function formatCheckoutCurrency(amount, currencyCode) {
  const value = amount == null ? "" : String(amount).trim();
  const code = currencyCode == null ? "" : String(currencyCode).trim();
  if (!value) return "";
  if (!code) return value;
  return `${value} ${code}`;
}
